// extracted by mini-css-extract-plugin
export default {"rating":"Yy-z","numberOfStars":"Zy-z","count":"_y-z","barGraphSpacing":"az-z","barGraph":"bz-z"};